import moment from "moment";

export const RPQ_STATUS = [
  "NONE",
  "VALID",
  "EXPIRED",
  "EXPIRING_1W",
  "EXPIRING_1M",
];

const EXPIRING_1W_DAYS = 7;
const EXPIRING_1M_DAYS = 30;

const getStartOfToday = (referenceDate = new Date()) =>
  moment(referenceDate).startOf("day");

const getLastRpq = (rpqArray) => {
  if (!rpqArray || rpqArray.length === 0) return null;
  return rpqArray[0];
};

export const resolveRpqStatus = (rpqArray, referenceDate = new Date()) => {
  const lastRpq = getLastRpq(rpqArray);
  if (!lastRpq) return "NONE";

  const expiryDate = lastRpq.expiryDate;
  if (!expiryDate) return "EXPIRED";

  const startOfToday = getStartOfToday(referenceDate);
  const expiry = moment(expiryDate).startOf("day");

  if (expiry.isBefore(startOfToday)) return "EXPIRED";

  const oneWeekOut = startOfToday.clone().add(EXPIRING_1W_DAYS, "days");
  if (expiry.isSameOrBefore(oneWeekOut)) return "EXPIRING_1W";

  const oneMonthOut = startOfToday.clone().add(EXPIRING_1M_DAYS, "days");
  if (expiry.isSameOrBefore(oneMonthOut)) return "EXPIRING_1M";

  return "VALID";
};

export const getEffectiveRpqStatus = (formValues = {}) => {
  const { rpq, rpqStatus } = formValues;
  if (rpq?.length) return resolveRpqStatus(rpq);
  return rpqStatus || "NONE";
};

export const RPQ_WARNING_CONFIG = {
  EXPIRED: {
    color: "red",
    title: "RPQ Expired",
    message: "This client's Risk Profile Questionnaire (RPQ) has expired.",
  },
  EXPIRING_1W: {
    color: "orange",
    title: "RPQ Expiring Soon",
    message:
      "This client's Risk Profile Questionnaire (RPQ) will expire within 1 week.",
  },
  EXPIRING_1M: {
    color: "yellow",
    title: "RPQ Expiring",
    message:
      "This client's Risk Profile Questionnaire (RPQ) will expire within 1 month.",
  },
};
